import React from "react";
import { TextField, Grid, useTheme, Typography, Modal, Backdrop } from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";
import AlertInfo from "components/AlertInfo";
import FormModal from "./Form";

const AddEmployeeModal = (props) => {
  const { open, onClose, title, onAccept,id, reloadFunc
  ,data,handleData,...rest } = props;
  // const theme = useTheme(); 


  return (
<>
    <Modal
        open={open}
        style={{Height:'100vh',width:'80%',marginRight:'10%',marginLeft:'10%', display: 'flex',
        justifyContent: 'center',
        alignItems: 'center', }}      
        
        onClose={onClose}
      >
        <div style={{backgroundColor:'white',padding:'2%',  border: "none",
}}>
        <FormModal handleData={handleData} onClose={onClose} data={data || undefined}  /> 

        </div>
      </Modal>
 

      {/* <AlertInfo
        fullWidth={true}
        onClose={onClose}
        onAccept={onAccept}
        {...rest}
        maxWidth={"sm"}
        title={props.title}
        open={open}
      >
       <Form edit={true}/>
      </AlertInfo> */}
  </>
  );
};

export default AddEmployeeModal;
